import { ShareModal } from "../../../../global/ShareModal/material/ShareModal";

export const ListingShareModal = () => {
  return (
    <ShareModal
      className={`w-[70vw] md:w-[400px] -bottom-[320px] md:-bottom-[300px] left-0 
          md:left-auto md:right-0 transform -translate-y-[1/2] absolute`}
    />
  );
};
